import { EAppletAuditStatus, EAppletConfigStatus, IPageParam } from '@core/main/types';

/**
 * 小程序管理查询请求参数
 */
export interface IAppletManageRequest extends IPageParam {
  /** 审核状态（0：未绑定，1：待发布，2：审核中，3：审核驳回,4：微信审核中,5：微信驳回 6 已发布） */
  auditStatus?: EAppletAuditStatus;
  /** 品牌方名称 */
  agentName?: string;
  /** 最新版本 */
  isLatestVersion?: EAppletLatestVersion;
}

/**
 * 小程序管理列表项
 */
export interface IAppletManageItem {
  /** 授权Id */
  appletId: number;
  /** 品牌方Id */
  agentId: number;
  /** 用户协议 */
  userAgreement: string;
  /** 用户协议名 */
  userAgreementName: string;
  /** 企业端隐私政策 */
  secretPolicy: string;
  /** 企业端隐私政策名 */
  secretPolicyName: string;
  /** 小程序名称 */
  appletName: string;
  /** 系统logo */
  sysLogo: string;
  /** 分享图片 */
  sharePic: string;
  /** 品牌方appId */
  appId: string;
  /** 刷新令牌 */
  authorizerRefreshToken: string;
  /** 配置状态(0：暂未绑定，1：使用中，2：已失效) */
  authStatus: EAppletConfigStatus;
  /** 自动升级状态(0：不自动升级，1：自动升级) */
  updateStatus: number;
  /** 审核状态（0：未绑定，1：待发布，2：审核中，3：审核驳回,4：微信审核中,5：微信驳回 6 已发布） */
  auditStatus: EAppletAuditStatus;
  /** 审核驳回原因 */
  rejectReason: string;
  /** 小程序版本号 */
  appletVersion: string;
  /** 小程序模板Id */
  tempId: number;
  /** 反馈内容 */
  feedbackInfo: string;
  /** 小程序版本说明和功能解释 */
  versionDesc: string;
  /** 联系电话 */
  phone: string;
  /** 公司地址 */
  companyAddress: string;
  /** 微信号 */
  wechat: string;
  /** 小程序权集 */
  appletPermissionList?: IAppletItemPermission[];
  /** 提审类目 */
  appletCategoryList?: IAppletCategoryItem[];
  /** 最新版本 */
  isLatestVersion: EAppletLatestVersion;
}

export enum EAppletLatestVersion {
  /** 是 */
  Yes = 1,
  /** 否 */
  No = 0,
}

export const appletLatestVersionLabel = {
  [EAppletLatestVersion.Yes]: '是',
  [EAppletLatestVersion.No]: '否',
};

export const appletLatestVersionStyle = {
  [EAppletLatestVersion.Yes]: 'success',
  [EAppletLatestVersion.No]: 'info',
};

export interface IAppletItemPermission {
  /** 权限集id */
  permissionId: number;
  /** 授权Id */
  appletId: number;
  /** 权限集id	 */
  id: number;
  /** 权限名称 */
  typeName: string;
  /** 权限描述 */
  typeDesc: string;
}

export interface IAppletCategoryItem {
  /** 类目Id */
  categoryId: number;
  /** 一级类目ID */
  first: number;
  /** 一级类目名称 */
  firstName: string;
  /** 二级类目ID */
  second: number;
  /** 二级类目名称 */
  secondName: string;
}
/**
 * 小程序重新发布请求参数
 */
export interface IAppletPublishRequest {
  /** 授权Id */
  appletId?: number;
  /** 代理商Id */
  agentId: number;
}

/**
 * 小程序配置协议请求参数
 */
export interface IAppletAgreementRequest {
  /** 授权Id */
  appletId: number;
  /** 代理商Id */
  agentId: number;
  /** 用户协议 */
  userAgreement: string;
  /** 用户协议名 */
  userAgreementName: string;
  /** 企业端隐私政策 */
  secretPolicy: string;
  /** 企业端隐私政策名 */
  secretPolicyName: string;
}

/**
 * 小程序送审资料请求参数
 */
export interface IAppletSubmitInfoRequest {
  /** 授权Id */
  appletId: number;
  /** 代理商Id */
  agentId: number;
}

/**
 * 小程序送审资料保存请求参数
 */
export interface IAppletSubmitInfoParam {
  /** 授权Id */
  appletId?: number;
  /** 反馈内容 */
  feedbackInfo?: string;
  /** 小程序版本说明和功能解释 */
  versionDesc?: string;
  /** 视频信息 */
  videoInfo?: string | string[];
  /** 图片list */
  imageList?: string[];
}

/**
 * 小程序送审资料详情返回
 */
export interface IAppletSubmitInfoRes extends Omit<IAppletSubmitInfoParam, 'videoInfo' | 'imageList'> {
  /** 视频信息 */
  videoInfo?: IAppletSubmitVideoInfo;
  /** 图片list */
  imageList?: IAppletSubmitImageInfo[];
}

export interface IAppletSubmitVideoInfo {
  /** 视频信息 */
  videoInfo?: string;
  /** mediaId */
  mediaId?: string;
}

export interface IAppletSubmitImageInfo {
  /** 图片信息 */
  picInfo?: string;
  /** mediaId */
  mediaId?: string;
}

/**
 * 小程序授权信息
 */
export interface IAppletAuthInfo {
  agentId: number;
  auth_code: number;
}